import React from "react";
import { navigateTo } from "../utils/navigation";

function handleBack() {
  if (typeof window !== "undefined" && window.history.length > 1) {
    window.history.back();
  } else {
    navigateTo("/");
  }
}

export default function PublicSupportPage(): React.JSX.Element {
  return (
    <div style={{ minHeight: '100dvh', background: 'var(--c-cream)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 'var(--s-7) var(--gutter)' }}>
      <div className="stack-5" style={{ width: '100%', maxWidth: '720px' }}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 var(--s-1)' }}>
          <button
            type="button"
            onClick={handleBack}
            className="btn btn--ghost"
            style={{ fontSize: '13px', padding: '10px 18px' }}
          >
            ← Back
          </button>
          <a href="/" className="logo" aria-label="kivo.skin home">
            kivo<span className="dot" />
          </a>
        </div>

        <div className="card card--bordered">

          <header style={{ marginBottom: 'var(--s-6)' }}>
            <p className="t-label" style={{ marginBottom: 'var(--s-3)' }}>Support</p>
            <h1 className="t-h2" style={{ margin: '0 0 var(--s-3)' }}>
              How can we <em className="t-italic t-teal">help?</em>
            </h1>
            <p className="t-small t-mute" style={{ margin: 0 }}>
              We read every message. Tell us what happened and we&apos;ll get back to you.
            </p>
          </header>

          <hr className="rule" style={{ marginBottom: 'var(--s-6)' }} />

          <section style={{ marginBottom: 'var(--s-6)' }}>
            <h2 className="t-h3" style={{ margin: '0 0 var(--s-4)' }}>Quick fixes</h2>
            <div className="stack-3">
              {[
                'Allow camera and photo permissions for kivo.skin in your browser settings.',
                'Update to the latest version of your browser.',
                'Hard refresh (Cmd/Ctrl + Shift + R) or try a private window.',
                'Use soft, even lighting for clearer appearance insights.',
              ].map((item) => (
                <div key={item} className="row-3" style={{ alignItems: 'flex-start' }}>
                  <span className="list-dot" />
                  <span className="t-small">{item}</span>
                </div>
              ))}
            </div>
          </section>

          <hr className="rule" style={{ marginBottom: 'var(--s-6)' }} />

          <section style={{ marginBottom: 'var(--s-6)' }}>
            <div className="g-2">

              <div className="card card--sand card--flat card--compact card--bordered stack-4">
                <div className="stack-2">
                  <p className="t-label" style={{ margin: 0 }}>Contact us</p>
                  <p className="t-small t-mute" style={{ margin: 0 }}>Typical reply time: 1–2 business days.</p>
                </div>
                <div className="stack-2">
                  <a
                    className="btn btn--primary"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                    href="mailto:support@kivo.skin?subject=Support%20Request&body=Describe%20what%20happened%20(and%20attach%20a%20screenshot%20if%20you%20can)."
                  >
                    Email support@kivo.skin
                  </a>
                  <button
                    type="button"
                    onClick={() => { navigateTo('/guide'); }}
                    className="btn btn--ghost"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                  >
                    Read capture tips
                  </button>
                </div>
              </div>

              <div className="card card--sand card--flat card--compact card--bordered stack-4">
                <div className="stack-2">
                  <p className="t-label" style={{ margin: 0 }}>Billing & plans</p>
                  <p className="t-small t-mute" style={{ margin: 0 }}>Questions about pricing or upgrades?</p>
                </div>
                <div className="stack-2">
                  <button
                    type="button"
                    onClick={() => { navigateTo('/plans'); }}
                    className="btn btn--ghost"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                  >
                    View plans
                  </button>
                  <a
                    className="btn btn--ghost"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                    href="mailto:support@kivo.skin?subject=Billing%20Question&body=Please%20include%20your%20account%20email%20(if%20you%20have%20one)%20and%20details."
                  >
                    Ask about billing
                  </a>
                </div>
              </div>

              <div className="card card--sand card--flat card--compact card--bordered stack-4">
                <div className="stack-2">
                  <p className="t-label" style={{ margin: 0 }}>Data & privacy</p>
                  <p className="t-small t-mute" style={{ margin: 0 }}>Learn how we store and protect your data, or make a request.</p>
                </div>
                <div className="stack-2">
                  <a
                    className="btn btn--ghost"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                    href="mailto:support@kivo.skin?subject=Data%20Request%20(Access%20or%20Deletion)&body=Please%20state%20your%20request%20and%20confirm%20your%20email."
                  >
                    Request my data / deletion
                  </a>
                  <button
                    type="button"
                    onClick={() => { navigateTo('/privacy'); }}
                    className="btn btn--ghost"
                    style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                  >
                    Read Privacy Policy
                  </button>
                </div>
              </div>

              <div className="card card--sand card--flat card--compact card--bordered stack-4">
                <div className="stack-2">
                  <p className="t-label" style={{ margin: 0 }}>Report a bug</p>
                  <p className="t-small t-mute" style={{ margin: 0 }}>Found something off in the experience? Let us know.</p>
                </div>
                <a
                  className="btn btn--ghost"
                  style={{ fontSize: '13px', padding: '10px 16px', justifyContent: 'center' }}
                  href="mailto:support@kivo.skin?subject=Bug%20Report&body=Steps%20to%20reproduce%3A%0AExpected%3A%0AActual%3A%0ABrowser%2FOS%3A"
                >
                  Send a bug report
                </a>
              </div>

            </div>
          </section>

          <hr className="rule" style={{ marginBottom: 'var(--s-6)' }} />

          <section style={{ marginBottom: 'var(--s-6)' }}>
            <div className="card card--sand card--flat card--compact card--bordered stack-4">
              <div className="stack-2">
                <p className="t-label" style={{ margin: 0 }}>A quiet moment</p>
                <p className="t-small t-mute" style={{ margin: 0 }}>
                  While we look into things, three minutes of smooth jazz won&apos;t fix the bug — but it might restore the vibe.
                </p>
              </div>
              <div className="row-3">
                <a
                  className="btn btn--primary"
                  style={{ fontSize: '13px', padding: '10px 16px' }}
                  href="https://open.spotify.com/search/jazz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Play some jazz
                </a>
                <button
                  type="button"
                  onClick={() => { navigateTo('/'); }}
                  className="btn btn--ghost"
                  style={{ fontSize: '13px', padding: '10px 16px' }}
                >
                  Back to home
                </button>
              </div>
              <p className="t-small t-mute" style={{ margin: 0, fontStyle: 'italic' }}>
                Unscientific — but a pleasant palate cleanser.
              </p>
            </div>
          </section>

          <hr className="rule" style={{ marginBottom: 'var(--s-6)' }} />

          <section style={{ marginBottom: 'var(--s-6)' }}>
            <p className="t-label" style={{ marginBottom: 'var(--s-4)' }}>Legal & compliance</p>
            <div className="stack-3">
              <p className="t-small" style={{ margin: 0 }}>
                See our{' '}
                <button
                  type="button"
                  onClick={() => { navigateTo('/terms'); }}
                  className="t-deep"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', textUnderlineOffset: '2px', font: 'inherit' }}
                >
                  Terms of Service
                </button>
                {', '}
                <button
                  type="button"
                  onClick={() => { navigateTo('/privacy'); }}
                  className="t-deep"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', textUnderlineOffset: '2px', font: 'inherit' }}
                >
                  Privacy Policy
                </button>
                {', '}
                <button
                  type="button"
                  onClick={() => { navigateTo('/ai-disclaimer'); }}
                  className="t-deep"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', textUnderlineOffset: '2px', font: 'inherit' }}
                >
                  AI Disclaimer
                </button>
                {', and '}
                <button
                  type="button"
                  onClick={() => { navigateTo('/photo-consent'); }}
                  className="t-deep"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', textUnderlineOffset: '2px', font: 'inherit' }}
                >
                  Biometric Consent
                </button>
                .
              </p>
              <p className="t-small" style={{ margin: 0 }}>
                EU/UK residents: exercise GDPR rights via the data & privacy links above or by emailing{' '}
                <a
                  href="mailto:support@kivo.skin"
                  className="t-deep"
                  style={{ textDecoration: 'underline', textUnderlineOffset: '2px' }}
                >
                  support@kivo.skin
                </a>
                .
              </p>
              <p className="t-small" style={{ margin: 0 }}>
                Security issue? Email with subject &quot;Security&quot; and we&apos;ll prioritize it.
              </p>
            </div>
          </section>

          <div>
            <button type="button" onClick={handleBack} className="btn btn--ghost">
              ← Back
            </button>
          </div>

        </div>

        <p className="t-small t-mute" style={{ textAlign: 'center', margin: 0 }}>
          © {new Date().getFullYear()} kivo.skin
        </p>
      </div>
    </div>
  );
}
